import store from "../../store";

const initialValues = () => {
  const values = store.getState().borrowerInfo;

  return {
    ...values,
  };
};

export default initialValues;



// WEBPACK FOOTER //
// ./src/Screens/BorrowerCredit/initialValues.js